/*@jsxRuntime automatic @jsxImportSource react*/
import {jsx as _jsx} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      p: "p"
    }, _provideComponents(), props.components);
    return _jsx(_components.p, {
      children: "Главная польза OCP — сделать так, чтобы изменение требований не затрагивало код уже созданных модулей, вынесение выбора фабрики в одно место — задача для SRP"
    });
  }
}
export default MDXContent;
